import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from './ui/button';
import { BadgeCheck, Loader2, Sparkles } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const PRICE_BY_COUNTRY = {
  UK: '£29/mo',
  IN: '₹2,499/mo',
  CA: 'C$49/mo',
};

const VerifiedPartnerCTA = ({ country = 'UK' }) => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const cc = (country || 'UK').toUpperCase();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    axios.get(`${API_URL}/api/partner/status`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setStatus(r.data)).catch(() => setStatus(null));
  }, []);

  const handleSubscribe = async () => {
    const token = localStorage.getItem('token');
    if (!token) { window.location.href = '/login?next=/agent'; return; }
    setLoading(true);
    try {
      const r = await axios.post(`${API_URL}/api/partner/subscribe`, {
        origin_url: window.location.origin, country: cc,
      }, { headers: { Authorization: `Bearer ${token}` } });
      if (r.data?.already_active) {
        toast.success('You are already a Verified Technology Service Partner.');
      } else if (r.data?.url) {
        window.location.href = r.data.url;
      }
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Checkout failed');
    } finally {
      setLoading(false);
    }
  };

  const isActive = status?.status === 'active';
  const price = PRICE_BY_COUNTRY[cc] || PRICE_BY_COUNTRY.UK;

  return (
    <div className="luxury-card p-6 mb-6 bg-gradient-to-br from-[#1F3D2B] via-[#2A4F39] to-[#1F3D2B] text-white" data-testid="verified-partner-cta">
      <div className="flex items-start gap-4">
        <div className="bg-[#E07A3A]/20 p-3 rounded-full">
          <BadgeCheck className="h-6 w-6 text-[#F0A875]" />
        </div>
        <div className="flex-1">
          <span className="text-[10px] tracking-[0.4em] text-[#F0A875] uppercase font-semibold">Verified Technology Service Partner</span>
          <h3 className="font-['Playfair_Display'] text-xl mt-1 leading-tight">Get NRI matches before they go public</h3>
          <p className="text-sm text-white/70 mt-1">
            Every Matchmaking Connection Fee on your listings is routed to your inbox instantly. Free Pulse Boost Pack on every claimed listing. Priority digest placement.
          </p>
        </div>
      </div>
      <div className="mt-4 flex flex-col sm:flex-row gap-3">
        {isActive ? (
          <div className="inline-flex items-center gap-2 bg-white/10 px-4 py-2 text-sm">
            <BadgeCheck className="h-4 w-4 text-emerald-300" /> Active until {new Date(status.expires_at).toLocaleDateString()}
          </div>
        ) : (
          <Button
            onClick={handleSubscribe}
            disabled={loading}
            className="bg-[#E07A3A] text-white hover:bg-[#C4652E] tracking-widest text-xs px-6 py-4 font-bold uppercase"
            data-testid="verified-partner-subscribe-btn"
          >
            {loading ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Sparkles className="h-4 w-4 mr-2" />}
            Verify & Join Network — {price}
          </Button>
        )}
      </div>
      <p className="text-[10px] text-white/40 mt-3">
        Matchmaking Service Fee. Shopperden is an AI Real Estate Network — not an estate agent or brokerage. Cancel anytime.
      </p>
    </div>
  );
};

export default VerifiedPartnerCTA;
